import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { listSkills } from '@/lib/api'
import type { Skill } from '@/types'
import { CardGrid, Card } from '@/components/ui/Card'
import { Badge } from '@/components/ui/Badge'
import { PendingBackendNotice } from '@/components/ui/EmptyState'

export function SkillsList() {
  const [skills, setSkills] = useState<Skill[]>([])

  useEffect(() => {
    listSkills().then(setSkills)
  }, [])

  return (
    <div>
      <PendingBackendNotice endpoint="GET /skills" />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h1 style={{ fontSize: 20, fontWeight: 500 }}>Skills</h1>
        <Link to="/skills/new" style={newButtonStyle}>+ Nuevo skill</Link>
      </div>
      <CardGrid>
        {skills.map((skill) => (
          <Link key={skill.id} to={`/skills/${skill.id}`}>
            <Card>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                <div style={{ fontSize: 14, fontWeight: 500 }}>{skill.name}</div>
                <Badge>{skill.skill_category}</Badge>
              </div>
              <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 8 }}>{skill.description}</p>
              <div className="mono" style={{ fontSize: 11 }}>{skill.id} · v{skill.version}</div>
            </Card>
          </Link>
        ))}
      </CardGrid>
    </div>
  )
}

const newButtonStyle: React.CSSProperties = {
  background: 'var(--surface-raised)',
  border: '1px solid var(--border-strong)',
  color: 'var(--text-primary)',
  borderRadius: 'var(--radius-sm)',
  padding: '6px 12px',
  fontSize: 13,
  display: 'inline-block',
}
